export const isEmptyHistory = (history, tab) => {
  if (!history || typeof history !== "object") {
    return true;
  }

  const isEmptyArrayOfObjects = (arr, fields) =>
    !arr ||
    arr.length === 0 ||
    arr.every((item) => fields.every((field) => !item[field] || item[field] === "" || item[field].length === 0));

  const isEmptyImage = (image) => !image || (!image.name && !image.originalName && !image.id);

  switch (tab) {
    case 0: {
      const descriptionField = "description" in history ? "description" : "comment";
      const nameField = "name" in history ? "name" : "ideaName";

      return (
        (!history[descriptionField] || history[descriptionField] === "") &&
        (!history[nameField] || history[nameField] === "") &&
        isEmptyImage(history.image) &&
        (!history.imagesLibrary || history.imagesLibrary.length === 0)
      );
    }
    case 1: {
      const benefitFields = [
        "potentialBenefitsOfContradictionSolving",
        "potentialBenefitsOfEureka",
        "potentialBenefitsOfMultiplication",
        "potentialBenefitsOfSubtraction",
        "potentialBenefitsOfReplacement",
        "benefits",
      ];
      const benefitField = benefitFields.find((field) => field in history);

      return (
        (!history.score || history.score === null) &&
        isEmptyArrayOfObjects(history[benefitField], ["name", "description", "target", "userInfo"])
      );
    }
    case 2: {
      return (
        isEmptyArrayOfObjects(history.issues, ["comment", "description", "createdByUser"]) &&
        (!history.issuesMessages || history.issuesMessages.length === 0) &&
        (!history.feasibleScore || history.feasibleScore === null) &&
        (!history.isIdeaFeasible || history.isIdeaFeasible === null)
      );
    }
    default: {
      return Object.keys(history).length === 0;
    }
  }
};
